import React from "react";
import { Link } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { LOGO } from "../../lib/assets";
import { MobileMenu } from "./MobileMenu";
import { useStickyMenu } from "../../lib/hooks/useStickyMenu";
import { FaWhatsapp } from "react-icons/fa6";

export const HeaderServiceOrder = () => {
  // menu sticky
  useStickyMenu();

  return (
    <>
      <div id="header-fixed-height"></div>

      <header className="header-style-four">
        <div id="sticky-header" className="menu-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="mobile-nav-toggler mt-3">
                  <i className="fas fa-bars"></i>
                </div>
                <div className="menu-wrap">
                  <nav className="menu-nav">
                    <div className="logo">
                      <Link to="/">
                        <img src={LOGO} alt="Logo" />
                      </Link>
                    </div>

                    {/* nav links */}
                    <div className="ml-[0.35rem] mt-[1.8rem] navbar-wrap main-menu d-none d-lg-flex p-[1rem] justify-center items-center">
                      <h6>
                        CONFIRMACIÓN DE DATOS PARA CERTIFICADO DE CALIBRACIÓN
                      </h6>
                    </div>

                    <div className="header-action mt-[0.8rem]">
                      <ul className="list-wrap">
                        <li className="offcanvas-menu offcanvas-menu-two">
                          <button type="button" className="menu-tigger">
                            <span></span>
                            <span></span>
                            <span></span>
                          </button>
                        </li>
                        <li className="header-contact-two">
                          <div className="icon">
                            <i>
                              <FaWhatsapp />{" "}
                            </i>
                          </div>
                          <div className="content">
                            <span>WhatsApp</span>
                            <a
                              href="https://api.whatsapp.com/send?phone=5614115353"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              56 1411 5353
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                {/* Mobile Menu  */}
                <MobileMenu />
              </div>
            </div>
          </div>
        </div>

        {/* sidebar */}
        <Sidebar />
      </header>
    </>
  );
};
